import React                     from 'react';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import DraggableResizableDialog2 from '../ui/DraggableResizableDialog2';
import billingLinkDialogModel    from './BillingLinkDialogModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  textContainer: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
});

interface IBillingLinkDialogProps {
}

type BillingLinkDialogProps = WithStyle<ReturnType<typeof styles>, IBillingLinkDialogProps>;

class BillingLinkDialog extends React.PureComponent<BillingLinkDialogProps> {
  constructor(props: BillingLinkDialogProps) {
    super(props);
  }

  renderDialogContents = React.memo((): JSX.Element => {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.textContainer}>
        <div className='content'>
          <Typography>You have no more users available in your subscription. Manage your plan to add more users.</Typography>
        </div>
      </div>
    )} />;
  });

  render() {
    return  <Observe render={() => (
      <DraggableResizableDialog2 defaultWidth='310px' DialogProps={{dialog: billingLinkDialogModel, disableEscapeKeyDown: false}} DraggableResizableBoxProps={{enableResizing: false, minWidth: '230px', minHeight: '207px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog2>
    )} />;
  }
}

export default withStyles<IBillingLinkDialogProps>(styles, BillingLinkDialog);
